import { Component, ViewChild } from '@angular/core';
import { LoginService } from './modules/login/login.service';
import { slideInAnimation } from './animations';
import { Router } from '@angular/router';
import { ChatService } from './modules/chat/_services/chat.service';
import { NotificationsService } from './modules/notifications/_services/notifications.service';
import { ChatDetailComponent } from './modules/chat/detail/chat-detail.component';
import { PhoneService } from './modules/phone/_services/phone.service';
import moment from 'moment';
import 'moment/locale/es';
import { environment } from 'src/environment/environment';
import { PrimeNG } from 'primeng/config';
import { LocalStorageService } from 'angular-web-storage';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
        slideInAnimation
    ],
    standalone: false
})
export class AppComponent {
  title = 'GUAi - Gestor de Operaciones';

  @ViewChild('chat') chat!: ChatDetailComponent;

  public is_public_route: boolean = false;  
  public is_user_logged: boolean = false;    
  public notificationsSidebarVisible: boolean = false;
  public listChatsSidebarVisible: boolean = false;
  public chatSidebarVisible: boolean = false;
  public phoneSidebarVisible: boolean = false;
  public chatTitle : string = '';
  public isProduction: boolean = environment.production;
  


  constructor(
    private loginService: LoginService,
    private router: Router,
    private chatService:ChatService,
    private notificationService: NotificationsService,
    private phoneService: PhoneService,
    private primengConfig: PrimeNG,
    private storage: LocalStorageService
  ) {

    this.router.events.subscribe((e) => {
      this.is_public_route = this.isPublicRoute();
    });

    this.loginService.onLogin.subscribe((logged:boolean) => {
      this.is_user_logged = logged;
    });
    this.loginService.checkSavedToken();

    this.notificationService.onShowSidebar.subscribe((visible:boolean) => {
      this.notificationsSidebarVisible = visible;
    });

    this.chatService.onOpenChat.subscribe((info:any) => {
      this.chat.loadChatRoom(info.code, info.title);
      this.chatSidebarVisible = true;
      this.chatTitle = info.title;
    });

    this.chatService.onCloseChat.subscribe(() => {
      this.chatSidebarVisible = false;
    });


    this.chatService.onOpenListChats.subscribe((info:any) => {
      this.listChatsSidebarVisible = true;
    });

    this.chatService.onCloseListChats.subscribe(() => {
      this.listChatsSidebarVisible = false;
    });
    this.phoneService.onShowSidebar.subscribe((visible:boolean) => {
      this.phoneSidebarVisible = visible;
    });

    this.primengConfig.setTranslation({
            accept: 'Aceptar',
            reject: 'Cancelar',
            monthNames: [ 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ],
            monthNamesShort: [ 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic' ],
            dayNames: [ 'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado' ],
            dayNamesShort: [ 'Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb' ],
            dayNamesMin: [ 'Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá' ],
            firstDayOfWeek: 1,
            today:'Hoy',
            clear: 'Limpiar',

            //translations
        });

    moment.locale('es');
    this.applyDarkModeFromStorage();

  }

  private applyDarkModeFromStorage() {
    if (this.storage.get('darkMode')) {
      document.body.classList.add('dark-mode');
      return;
    }

    document.body.classList.remove('dark-mode');
  }

  ngAfterViewInit() {
    
  }

  isPublicRoute(){
    return this.router.url.includes('public/');
  }

  onChatHide(){
    this.chatService.onCloseChat.emit();
    this.chatService.onOpenListChats.emit();
  }
  
  onChatListHide(){
    this.chatService.onCloseListChats.emit();
  }

  
}
